import * as yup from "yup";

const createHelpSchema = (t) =>
    yup.object().shape({
        email: yup
            .string()
            .email(t("validation.pleaseEnterValidEmail"))
            .required(t("validation.emailRequired")),
        name: yup.string().required(t("validation.nameRequired")),
        ticket: yup
            .string()
            .required(t("validation.ticketRequired"))
            .min(10, t("validation.ticketMinLength")),
    });

export default createHelpSchema;